import { frameNames } from '../constants';
import { PixiBase } from '../core/pixi/PixiBase';
import { betBarStore } from '../store/betBarStore';
import { gameMainDrawer } from '../game/drawers/gameMainDrawer';
import { spinBarStore } from '../store/spinBarStore';
import { gameStore } from '../store/gameStore';
import { boostedJackpotStore } from '../store/boostedJackpotStore';

export const updateBetAmountButtonsState = (value) => {
  gameMainDrawer.betBar.updateBetBarButtonsAmountState(value);
  gameMainDrawer.introBar.updateSettingsBarButtonsAmountState(value);

  if (value !== betBarStore.selectedAmount) {
    PixiBase.changeFrame(
      gameMainDrawer.betBar.betAmountButtons[betBarStore.selectedAmount],
      frameNames.NormalBetButtonState
    );
  }
  betBarStore.setSelectedAmount(value);
  gameMainDrawer.introBar.updatePayTableOddInfo();
};

export const betButtonStates = (container, isSettings) => {
  const texture = container.children[0];
  PixiBase.registerClick(container, (e) => {
    if (
      spinBarStore.isSpinStart ||
      spinBarStore.isAutoBetStart ||
      gameMainDrawer.popupBar.isOpenPopup
    ) {
      return;
    }
    betBarStore.setIsPointerDown(true);
    if (e.target.amountValue === betBarStore.selectedAmount) {
      PixiBase.changeFrame(texture, frameNames.SelectedHoverButton);
    } else {
      PixiBase.changeFrame(texture, frameNames.ClickedBetButtonState);
    }
  });

  PixiBase.registerPointerup(container, (e) => {
    const freeBetCount = gameStore.tournamentInfoInitial?.freeBetCount
      ? gameStore.tournamentInfoInitial?.freeBetCount
      : spinBarStore.freeBetList[spinBarStore.activeFreeBetIndex]?.remainingCount;
    const freeBetAmount = gameStore.tournamentInfoInitial?.freeBetPGCoinAmount
      ? gameStore.tournamentInfoInitial?.freeBetPGCoinAmount
      : spinBarStore.freeBetList[spinBarStore.activeFreeBetIndex]?.amount;
    const { amountValue } = e.target;
    if (spinBarStore.isSpinStart) {
      if (+amountValue === +betBarStore.selectedAmount) {
        spinBarStore.setIsDoubleClick(true);
      }
      return;
    }
    if (
      !spinBarStore.isSpinStart &&
      boostedJackpotStore.isBoostedJackpot &&
      boostedJackpotStore.boostedBetAmount <= e.target.amountValue &&
      gameMainDrawer.boostedJackpot.wheelIcon.getCurrentAnimationName() !== 'active'
    ) {
      gameMainDrawer.boostedJackpot.updateWheelIconAnimation('active');
    } else if (boostedJackpotStore.boostedBetAmount > e.target.amountValue) {
      gameMainDrawer.boostedJackpot.updateWheelIconAnimation('idle');
    }
    if (betBarStore.isPointerDown && (isSettings ? true : gameMainDrawer.betBar.isDraggingEnd)) {
      betBarStore.setIsPointerDown(false);
      if (Boolean(freeBetCount) && freeBetAmount !== amountValue) {
        PixiBase.changeFrame(texture, frameNames.NormalBetButtonState);
        return;
      }
      updateBetAmountButtonsState(amountValue);
      !isSettings && gameMainDrawer.spinBar.handleDoSpin();
    }
  });
  PixiBase.registerPointerover(container, (e) => {
    if (spinBarStore.isSpinStart) {
      return;
    }
    if (e.target.amountValue !== betBarStore.selectedAmount) {
      PixiBase.changeFrame(container.children[0], frameNames.HoverBetButtonState);
    }
  });
  PixiBase.registerPointerout(container, (e) => {
    if (spinBarStore.isSpinStart) {
      return;
    }
    if (e.target.amountValue !== betBarStore.selectedAmount) {
      PixiBase.changeFrame(container.children[0], frameNames.NormalBetButtonState);
    } else if (e.target.amountValue === betBarStore.selectedAmount) {
      PixiBase.changeFrame(container.children[0], frameNames.SelectedQuickBetState);
    }
  });
};
